export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_15.ff747923.jpg";